import useColumnLayout from "../hooks/useColumnLayout";

export type Layout = {
  columns: number;
  threshold: number;
};

type ColumnLayoutProps = {
  layouts: Layout[];
  items: JSX.Element[];
};

function ColumnLayout({ layouts, items }: ColumnLayoutProps) {
  const columns = useColumnLayout(layouts, items);

  return (
    <div className="flex space-x-4">
      {columns.map((column, i) => (
        <div
          key={`layout-column-${i}`}
          className="flex w-0 flex-[1_1_0px] flex-col space-y-4"
        >
          {column}
        </div>
      ))}
    </div>
  );
}

export default ColumnLayout;
